export function Logo({ variant = "light", className = "h-8" }) {
  const img = <img src="/novacert.png" alt="NovaCert" className={`${className} w-auto object-contain`} />;
  if (variant === "dark")
    return <span className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5">{img}</span>;
  return img;
}

export function LogoIcon({ className = "h-9 w-9" }) {
  return <img src="/novacert-icon.png" alt="NovaCert" className={`${className} object-contain`} />;
}
